module.exports = "/glooko-logo-whitebb17cab9eed66d16e65ee5d702b253f6.svg";